<template>
  <div ref="page">
    <Grid v-if="showThemebar" variant="default" class="grid">
      <PageThemeBar :centered="false" overview-label="Overzicht" heading="Opiniepanel" />
    </Grid>
    <NuxtPage />
  </div>
</template>

<script setup lang="ts">
const route = useRoute();

const showThemebar = computed(() => {
  return route.meta.showThemebar === true;
});
</script>

<style lang="postcss" scoped>
.grid {
  margin-top: 16px !important;
  margin-bottom: 16px !important;

  @media (--md-viewport) {
    margin-top: 16px !important;
    margin-bottom: 24px !important;
  }

  @media (--lg-viewport) {
    margin-bottom: 32px !important;
  }
}
</style>
